var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Wensenlijst',{attrs:{"alleWensen":_vm.wensen},on:{"verwijder-wens":_vm.verwijderWens}}),_c('MaakWens',{on:{"voeg-boek-toe":_vm.voegBoekToe}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }